// extracted by mini-css-extract-plugin
export default {"errors":"CustomControl__errors--Kq8VAS"};